import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, MenuProps } from 'antd';
import { setStoredLanguage } from 'utils/languagePreference';

const LanguageSwitcher: React.FC = () => {
    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState<string>(
        i18n.resolvedLanguage || i18n.language || 'en'
    );

    // 监听语言变化，确保显示更新
    useEffect(() => {
        const updateLanguage = () => {
            const lang = i18n.resolvedLanguage || i18n.language || 'en';
            setCurrentLang(lang);
        };

        i18n.on('languageChanged', updateLanguage);
        updateLanguage(); // 初始化时也更新一次

        return () => {
            i18n.off('languageChanged', updateLanguage);
        };
    }, [i18n]);

    const getLanguageDisplay = () => {
        // 规范化语言代码，处理 'zh-CN', 'en-US' 等变体
        const normalizedLang = currentLang.toLowerCase().split('-')[0];
        switch (normalizedLang) {
            case 'zh':
                return '中';
            case 'es':
                return 'Es';
            default:
                return 'En';
        }
    };

    const changeLanguage = (lng: string) => {
        // 先保存到 localStorage，确保刷新后能读取到正确的语言
        setStoredLanguage(lng);
        // 然后切换语言，i18n 会自动读取 localStorage 中的值
        i18n.changeLanguage(lng)
            .then(() => {
                // 刷新页面，确保所有内容都更新到新语言
                window.location.reload();
            })
            .catch((err: Error) => {
                console.error('Error changing language:', err);
            });
    };

    const languageItems: MenuProps['items'] = [
        {
            key: 'en',
            label: t('preferences.language.options.en'),
        },
        {
            key: 'zh',
            label: t('preferences.language.options.zh'),
        },
        {
            key: 'es',
            label: t('preferences.language.options.es'),
        },
    ];

    const handleLanguageChange: MenuProps['onClick'] = (e) => {
        changeLanguage(e.key);
    };
    
    return (
            <Dropdown
                menu={{ items: languageItems, onClick: handleLanguageChange }}
                placement="top"
                arrow>
                <div className="flex items-center cursor-pointer">
                    <Button type="default" shape='circle'>
                        {getLanguageDisplay()}
                    </Button>
                </div>
            </Dropdown>
    );
};

export default LanguageSwitcher; 